import { Reveal } from "@/components/Reveal";

const FACTS = [
  { k: "Cloud-based", v: "Property Intelligence & Management Platform" },
  { k: "Built in Ghana", v: "For African real estate, to global standards" },
  { k: "Every portfolio", v: "Residential, commercial, mixed-use and institutional" },
  { k: "One platform", v: "Operations, maintenance, finances and intelligence" },
];

export const TrustStrip = () => (
  <section className="border-y border-navy/10 bg-mist/60 py-10 md:py-12" data-testid="trust-strip">
    <div className="container-x grid grid-cols-2 gap-6 md:grid-cols-4 md:gap-8">
      {FACTS.map((f, i) => (
        <Reveal key={f.k} delay={i * 0.06}>
          <div data-testid={`credibility-${f.k.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
            <p className="font-display text-sm font-extrabold uppercase tracking-wide text-navy">{f.k}</p>
            <p className="mt-1.5 text-sm leading-relaxed text-slate2">{f.v}</p>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
